// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.RentalManagerUserPropertyFloorPlanCreateWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyFloorPlanCreateWebApiHandler_create } from '@zg-rentals/ts-rental-manager-api-client';

import type { ListingAlias, UserPropertyFloorPlanCreateResponseWebDto } from '@zg-rentals/ts-rental-manager-api-client';

interface CreateParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertyFloorPlanCreateWebApiHandler_create_Args {
  getParams: CreateParams;
}

export type RentalManagerUserPropertyFloorPlanCreateWebApiHandler_create_Options = UseMutationOptions<
  UserPropertyFloorPlanCreateResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanCreateWebApiHandler_create_Args
>;

/**
 * Create a floor plan for the property
 */
export const useRentalManagerUserPropertyFloorPlanCreateWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanCreateWebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanCreateWebApiHandler_create_Args) =>
      RentalManagerUserPropertyFloorPlanCreateWebApiHandler_create(args.getParams, httpClient),
  });
};
